export const tableHeadData = [
  {
    label: 'Bericht-Nr.',
    attribute: 'publicId',
    type: 'text',
    fieldWidth: 2 / 10,
  },
  {
    label: 'Empfänger',
    attribute: 'receiver.lastname',
    type: 'text',
    fieldWidth: 3 / 10,
  },
  {
    label: 'Datum',
    attribute: 'meta.modified',
    type: 'date',
    fieldWidth: 2 / 10,
  },
  {
    label: 'Status',
    attribute: 'status',
    type: 'number',
    fieldWidth: 2 / 10,
  },
  {
    label: 'PDF',
    attribute: 'url',
    type: 'text',
    fieldWidth: 1 / 10,
  },
];
